import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { CoreModule, JurisdictionPrefixModule } from "@obg/ngx.core";
import { CoreUiModule } from "@obg/ngx.ui.core";
import { GlobalUiModule } from "@obg/ngx.ui.global";

import { AamsRegulatoryBarContainer } from "./aams/aams-regulatory-bar.container";
import { AamsGameRegulatoryBarContainer } from "./aams/game/aams-game-regulatory-bar.container";
import { AamsSessionInfoBarContainer } from "./aams/session-info-bar/aams-session-info-bar.container";
import { KsaRegulatoryBarContainer } from "./ksa/ksa-regulatory-bar.container";
import { PanicButtonModule } from "./panic-buttom/panic-button.module";
import { RegulatoryBarContainer } from "./regulatory-bar.container";
import { SessionTimerRegulatoryBarContainer } from "./session-timer/session-timer-regulatory-bar.container";
import { GamblingSummaryModalContainer } from "./standard/gambling-summary/gambling-summary-modal.container";
import { StandardRegulatoryBarContainer } from "./standard/standard-regulatory-bar.container";

const DIRECTIVES: any[] = [
	RegulatoryBarContainer,
	StandardRegulatoryBarContainer,
	GamblingSummaryModalContainer,
	KsaRegulatoryBarContainer,
	AamsRegulatoryBarContainer,
	AamsSessionInfoBarContainer,
	AamsGameRegulatoryBarContainer,
	SessionTimerRegulatoryBarContainer,
];

@NgModule({
	imports: [
		CommonModule,
		CoreModule,
		CoreUiModule,
		GlobalUiModule,
		JurisdictionPrefixModule,
		TranslateModule,
		PanicButtonModule,
	],
	exports: [...DIRECTIVES],
	declarations: [...DIRECTIVES],
})
export class RegulatoryBarModule {}
